var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeNoEvilMonkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.3 74.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".monkey-1{fill:#88664c;}.monkey-2{fill:#f4c2d2;}.monkey-3{fill:#e0ac7d;}.monkey-4{fill:#3b3029;}.monkey-5{fill:#f9d4bc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "monkey-1",
    d: "M68.4,24.76A10.88,10.88,0,1,1,57.49,35.64,10.89,10.89,0,0,1,68.4,24.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-2",
    d: "M68.4,28.56a7.09,7.09,0,1,1-7.1,7.08A7.08,7.08,0,0,1,68.4,28.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-1",
    d: "M10.9,24.76A10.88,10.88,0,1,1,0,35.64,10.89,10.89,0,0,1,10.9,24.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-2",
    d: "M10.9,28.56a7.09,7.09,0,1,1-7.1,7.08A7.08,7.08,0,0,1,10.9,28.56Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-1",
    d: "M54.68,6.32c1.52-.8,2.5-1.2,2.5-1.2A53.85,53.85,0,0,0,46,2.34,15,15,0,0,1,48.79.58C21.81-3.22,9,12.42,9,26.3H70.34C69.42,16.63,64,10,54.68,6.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-1",
    d: "M70.48,28.5c0-12.83-13.81-23.22-30.83-23.22S8.82,15.68,8.82,28.51A18.29,18.29,0,0,0,11,37a18.33,18.33,0,0,0-2.16,8.5c0,12.83,13.8,23.23,30.83,23.23S70.48,58.33,70.48,45.5A18.37,18.37,0,0,0,68.32,37,18.3,18.3,0,0,0,70.48,28.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-3",
    d: "M66.11,29.35c0-22.38-26.46-8.13-26.46-8.13S13.19,7,13.19,29.35c0,6.26,3.85,11.84,9.88,15.48a11.91,11.91,0,0,0-2.79,7.49c0,8,8.68,14.55,19.37,14.55S59,60.36,59,52.32a11.91,11.91,0,0,0-2.79-7.49C62.26,41.19,66.11,35.61,66.11,29.35Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-4",
    d: "M43.81,43.28c0,1.5-.59,2.71-1.32,2.71s-1.33-1.21-1.33-2.71.6-2.72,1.33-2.72S43.81,41.78,43.81,43.28Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-4",
    d: "M38.14,43.28c0,1.5-.59,2.71-1.33,2.71s-1.32-1.21-1.32-2.71.59-2.72,1.32-2.72S38.14,41.78,38.14,43.28Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-4",
    d: "M45.27,52.11c3.15-.91,6.16-.1,6.71,1.81s-1.57,4.19-4.72,5.1-6.16.1-6.71-1.81S42.11,53,45.27,52.11Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-1",
    d: "M9.68,35.14,0,74H15.79c-2.06-10.2,5.29-27.76,5.29-27.76Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-5",
    d: "M18.05,25s6.44-5.93,12.54-5.21c3,.35-9.36,10-9.36,10S34.07,19,36.73,22.36c2.41,3.1-11.8,13-11.8,13s13.16-10.65,12.75-6c-.45,5.11-10.41,17-16.5,18.21-8.78,1.75-15.58-3.85-11-23.14C12.49,14.73,14.86,25.52,18.05,25Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-1",
    d: "M69.62,35.14,79.3,74H63.51c2.06-10.2-5.29-27.76-5.29-27.76Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "monkey-5",
    d: "M61.26,25s-6.45-5.93-12.55-5.21c-3,.35,9.36,10,9.36,10S45.23,19,42.58,22.36c-2.41,3.1,11.79,13,11.79,13s-13.15-10.65-12.75-6c.45,5.11,10.41,17,16.5,18.21,8.78,1.75,15.58-3.85,11-23.14C66.81,14.73,64.44,25.52,61.26,25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeNoEvilMonkey);
export default __webpack_public_path__ + "static/media/see_no_evil_monkey.c2184b03361dfcffe13732656f6d17c2.svg";
export { ForwardRef as ReactComponent };